/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RmCalculationType = {
    Total: 'Total',
    PerTierAndTheme: 'PerTierAndTheme',
    PerTierAndLicenseMark: 'PerTierAndLicenseMark',
    CopyLocalLeadRmToLocalRm: 'CopyLocalLeadRmToLocalRm',
    PerTierAndGroup: 'PerTierAndGroup'
} as const;
export type RmCalculationType = typeof RmCalculationType[keyof typeof RmCalculationType];


export function instanceOfRmCalculationType(value: any): boolean {
    for (const key in RmCalculationType) {
        if (Object.prototype.hasOwnProperty.call(RmCalculationType, key)) {
            if (RmCalculationType[key as keyof typeof RmCalculationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RmCalculationTypeFromJSON(json: any): RmCalculationType {
    return RmCalculationTypeFromJSONTyped(json, false);
}

export function RmCalculationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RmCalculationType {
    return json as RmCalculationType;
}

export function RmCalculationTypeToJSON(value?: RmCalculationType | null): any {
    return value as any;
}

export function RmCalculationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RmCalculationType {
    return value as RmCalculationType;
}

